<template>
    <div class="page contain wider">
        <div class="section info title-only mb-10px" v-if="pfLoaded">
            <div class="left">
                <h1 class="main-title">{{ portfolioTitle }}</h1>
            </div>
            <div class="right buttons">
                <TableListColumnEditButton/>
                <!-- <div class="button green" :class="{basic: !autoReload}" @click="toggleAutoReload">
                    <span>Auto reload:
                        <span v-if="autoReload">ON</span>
                        <span v-else>OFF</span>
                    </span>
                </div> -->
                <div class="button green px-8px" @click="refreshPortfolio"><span class="material-icons valign-middle text-23px">refresh</span></div>
                <ValidateSheetButton :spreadsheets="spreadsheets"/>
            </div>
        </div>
        <Portfolio ref="Portfolio" :spreadsheets="spreadsheets" @loaded="pfLoaded = true"/>
    </div>
</template>

<script>
import Portfolio from '@/components/Portfolio.vue'
import TableListColumnEditButton from '@/components/table/TableListColumnEditButton.vue'
import ValidateSheetButton from '@/components/sheet-validation/ValidateSheetButton.vue'

export default {
    components:{
        Portfolio,
        TableListColumnEditButton,
        ValidateSheetButton,
    },
    data(){
        return{
            spreadsheetKey: this.$route.params.sheetsId || null,
            spreadsheetTab: this.$route.params.sheetsTab || 1,
            pfLoaded: false,
            // autoReload: (localStorage.getItem('autoreload') || 'false') == 'true',
            autoReload: false,
            reloadInterval: null,
        }
    },
    created(){
        this.reloadInterval = window.setInterval(()=>{
            if(this.pfLoaded && this.autoReload){
                this.refreshPortfolio()
            }
        }, 10000)
    },
    beforeDestroy(){
        window.clearInterval(this.reloadInterval)
    },
    computed:{
        isCombinedPortfolio(){
            return this.spreadsheetKey == null
        },
        spreadsheets(){
            if(!this.isCombinedPortfolio){
                // single portfolio
                return [{key:this.spreadsheetKey, tab:this.spreadsheetTab}]
            }
            // combined portfolio
            const portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')
            return portfolios.map(pf => ({key:pf.spreadsheetKey, tab:pf.spreadsheetTab}))
        },
        portfolioTitle(){
            if(this.isCombinedPortfolio){
                return 'Full portfolio'
            }
            const portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')
            return portfolios.find(pf => pf.spreadsheetKey == this.spreadsheetKey && pf.spreadsheetTab == this.spreadsheetTab).name
        },
    },
    methods:{
        refreshPortfolio(){
            if(!this.$refs.Portfolio){
                return
            }
            this.$refs.Portfolio.loadcurrentCoingeckoFeedMap()
        },
        toggleAutoReload(){
            this.autoReload = !this.autoReload
            localStorage.setItem('autoreload', this.autoReload)
        }
    }
}
</script>